import React, { useRef, useContext, useState, useEffect } from 'react';
import './styles.css'
import { useForm } from 'react-hook-form';
import * as FcIcons from 'react-icons/fc';

import AxiosService from '../services/axios.service';

function List(match) {
    const { path } = match;
    const [cases, setCases] = useState(null);
    const [results, setResults] = useState(0);

    const { register, watch, formState: { errors }, handleSubmit } = useForm();

    function search() {
        let today = new Date().toISOString().slice(0, 10);
        var keyword = watch("query").toLowerCase();
        AxiosService.getAll("cases").then(x => {
            var queries = x.data.filter(item => item.deadline >= today)
            queries.sort((a, b) => new Date(a.deadline) - new Date(b.deadline));
            queries = queries.filter(item => item.case_name.toLowerCase().includes(keyword) || item.document_type.includes(keyword));
            setCases(queries);
            setResults(queries.length);
        }
        );
    }

    useEffect(() => {
        let today = new Date().toISOString().slice(0, 10);
        AxiosService.getAll("cases").then(x => {
            var queries = x.data.filter(item => item.deadline >= today)
            queries.sort((a, b) => new Date(a.deadline) - new Date(b.deadline));
            setCases(queries)
            setResults(queries.length)
            console.log(queries);
        }
        );
    }, []);

    return (
        <div>
            <h1 style={{ textAlign: 'center' }}>Mark-Up</h1>
            <form onSubmit={handleSubmit(search)} onReset={useEffect}>
                <div className="form-row">
                    <div className="form-group col-5">
                        <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.query?.message}</div>
                    </div>
                    <div className="form-group col-5">
                        {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
                        <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
                    </div>
                </div>
            </form>
            <h5>Results: {results}</h5>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>Case Name</th>
                        <th style={{ width: '10%' }}>Deadline</th>
                        <th style={{ width: '60%' }}>Document Type</th>
                    </tr>
                </thead>
                <tbody>
                    {cases && cases.map(case_ =>
                        <tr key={case_.id}>
                            <td>{case_.case_name}</td>
                            <td>{case_.deadline}</td>
                            <td>{case_.document_type}</td>
                        </tr>
                    )}
                    {!cases &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {cases && !cases.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No Users To Display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}

export { List };